/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientModel } from '../../models/patient-model';

export interface GetPatients$Params {
}

export function GetPatients(http: HttpClient, rootUrl: string, params?: GetPatients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatients.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientModel>>;
    })
  );
}

GetPatients.PATH = '/api/Parent/GetPatients';
